import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b37dba58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "validate-title" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Todos ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Un parametro ")
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_13 = { class: "form-item" }
const _hoisted_14 = { class: "form-item" }
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_stationDataTrainingComponent = _resolveComponent("stationDataTrainingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  "label-position": "top",
                  ref: "myForm",
                  model: _ctx.trainingDataForm,
                  rules: _ctx.rules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("title.downloadTrainingData")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_form_item, {
                                prop: "container",
                                label: _ctx.$t('label.container')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.trainingDataForm.container,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingDataForm.container) = $event)),
                                    filterable: "",
                                    "value-key": "id",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containers, (option) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: option.id,
                                          label: option.name,
                                          value: option
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_form_item, {
                                prop: "samplingPointType",
                                label: _ctx.$t('label.samplingPointType'),
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (
                        _ctx.trainingDataForm.container &&
                        _ctx.trainingDataForm.container.containerType?.samplingPointType &&
                        _ctx.trainingDataForm.container.containerType?.samplingPointType?.length > 1
                      )
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 0,
                                        modelValue: _ctx.trainingDataForm.samplingPointType,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainingDataForm.samplingPointType) = $event)),
                                        "value-key": "id",
                                        style: {"width":"100%"},
                                        filterable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainingDataForm.container.containerType
                          ?.samplingPointType, (option) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: option.id,
                                              label: option.name,
                                              value: option.name
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : (_openBlock(), _createBlock(_component_el_select, {
                                        key: 1,
                                        disabled: "",
                                        style: {"width":"100%"}
                                      }))
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_el_form_item, {
                                prop: "origin",
                                label: _ctx.$t('label.origin'),
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.trainingDataForm.origin,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainingDataForm.origin) = $event)),
                                    "value-key": "value",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originList, (option) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: option.value,
                                          label: option.label,
                                          value: option.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.parameters')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.changesParameterType,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.changesParameterType) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio, { label: true }, {
                                        default: _withCtx(() => [
                                          _hoisted_7
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio, { label: false }, {
                                        default: _withCtx(() => [
                                          _hoisted_8
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              (!_ctx.changesParameterType)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    prop: "parameters"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.trainingDataForm.codeParameter,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainingDataForm.codeParameter) = $event)),
                                        "value-key": "value",
                                        filterable: "",
                                        style: {"width":"100%"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (option) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: option.code,
                                              label: option.name,
                                              value: option.code
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_el_form_item, {
                                class: "block",
                                label: _ctx.$t('label.fromDate'),
                                prop: "startDate",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_el_date_picker, {
                                    modelValue: _ctx.trainingDataForm.startDate,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainingDataForm.startDate) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    "start-placeholder": "Desde",
                                    clearable: false,
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    style: {"width":"100%"},
                                    key: _ctx.dateKey
                                  }, {
                                    default: _withCtx((cell) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                                        }, _toDisplayString(cell.text), 3),
                                        (_ctx.hasEstimatedData(cell.date))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.endDate'),
                                prop: "endDate",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_el_date_picker, {
                                    modelValue: _ctx.trainingDataForm.endDate,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainingDataForm.endDate) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    "start-placeholder": "Hasta",
                                    class: "block",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    style: {"width":"100%"},
                                    key: _ctx.dateKey
                                  }, {
                                    default: _withCtx((cell) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                                        }, _toDisplayString(cell.text), 3),
                                        (_ctx.hasEstimatedData(cell.date))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_el_button, {
                                loading: _ctx.loading,
                                type: "primary",
                                class: "btn",
                                size: "large",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.visualizeData())),
                                round: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("btn.visualize")), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, { gutter: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { lg: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_button, {
                                loading: _ctx.loading,
                                type: "primary",
                                class: "btn",
                                size: "large",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downoloadData())),
                                round: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("btn.download")), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                (_ctx.visualize)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_stationDataTrainingComponent, {
                        ref: "list",
                        entities: _ctx.dataTraining.data,
                        data: _ctx.dataTraining.data,
                        onLoad: _ctx.visualizeData
                      }, null, 8, ["entities", "data", "onLoad"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}